
// export function isShopOpenNow(openingHours) {
//   if (!openingHours) return false;

//   const now = new Date();
//   const weekday = now.toLocaleDateString("en-US", { weekday: "long" }).toLowerCase();
//   const todaysHours = openingHours[weekday];

//   if (!Array.isArray(todaysHours) || todaysHours.length === 0) return false;

//   const nowMinutes = now.getHours() * 60 + now.getMinutes();

//   for (const interval of todaysHours) {
//     const trimmed = interval.trim().toLowerCase();
//     if (trimmed === "closed") continue;

//     const [start, end] = trimmed.split("-");
//     if (!start || !end) continue;

//     const [startH, startM] = start.split(":").map(Number);
//     const [endH, endM] = end.split(":").map(Number);
//     if (isNaN(startH) || isNaN(startM) || isNaN(endH) || isNaN(endM)) continue;

//     const startMinutes = startH * 60 + startM;
//     const endMinutes = endH * 60 + endM;

//     if (endMinutes > startMinutes) {
//       // Normal interval
//       if (nowMinutes >= startMinutes && nowMinutes <= endMinutes) return true;
//     } else {
//       // Cross-midnight
//       if (nowMinutes >= startMinutes || nowMinutes <= endMinutes) return true;
//     }
//   }

//   return false;
// }
// openingHours keys: monday..sunday (lowercase, English)
// values: array of strings like ["09:00-21:45"] or ["closed"]
// Example:
// const openingHours = {
//   monday: ["09:00-21:45"],
//   tuesday: ["09:00-21:45"],
//   wednesday: ["09:00-21:45"],
//   thursday: ["09:00-21:45"],
//   friday: ["09:00-23:30"],
//   saturday: ["10:00-02:00"], // crosses midnight
//   sunday: ["closed"]
// };

function minutesOf(timeStr) {
  const [h, m] = String(timeStr).split(":").map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return null;
  return h * 60 + m;
}

function nowInTimezoneMinutes(tz) {
  // Get weekday, hour, minute as seen in the shop's timezone
  const d = new Date();
  const fmt = new Intl.DateTimeFormat("en-US", {
    timeZone: tz,
    hour12: false,
    weekday: "long",
    hour: "2-digit",
    minute: "2-digit",
  });
  const parts = Object.fromEntries(fmt.formatToParts(d).map(p => [p.type, p.value]));
  const weekday = String(parts.weekday || "").toLowerCase(); // "monday", ...
  const nowMinutes = Number(parts.hour) * 60 + Number(parts.minute);
  return { weekday, nowMinutes };
}

export function isShopOpenNow(openingHours, shopTimeZone = "Europe/Warsaw") {
  if (!openingHours) return false;

  const { weekday, nowMinutes } = nowInTimezoneMinutes(shopTimeZone);
  const todays = openingHours[weekday];
  if (!Array.isArray(todays) || todays.length === 0) return false;

  for (const interval of todays) {
    const s = String(interval || "").trim().toLowerCase();
    if (!s || s === "closed") continue;

    const [startStr, endStr] = s.split("-");
    if (!startStr || !endStr) continue;

    const startMin = minutesOf(startStr);
    const endMin = minutesOf(endStr);
    if (startMin == null || endMin == null) continue;

    if (endMin > startMin) {
      // Normal same-day interval (end is EXCLUSIVE)
      if (nowMinutes >= startMin && nowMinutes < endMin) return true;
    } else {
      // Cross-midnight, e.g. 20:00-02:00 (end next day)
      // Open if now >= start OR now < end
      if (nowMinutes >= startMin || nowMinutes < endMin) return true;
    }
  }

  return false;
}
